export default __webpack_public_path__ + "static/media/here-to-help.899751b0.svg";